import React, { useState, useEffect } from "react";
import { Button, message, Table, Tooltip, Space } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import http from "../../../../../services/http";

export const SugestoesAnexos = ({ idSugestao }) => {
	const [loading, setLoading] = useState(false);
	const [dados, setDados] = useState([]);

	useEffect(() => {
		if (idSugestao > 0) {
			listarSugestoesAnexos(idSugestao);
		}
	}, [idSugestao]);

	// LISTAR
	const listarSugestoesAnexos = async (id_sugestao) => {
		setLoading(true);
		const api = await http("get", `v1/sugestoes_anexos/listar/${id_sugestao}`, []);
		if (api.statusCode === 200) {
			setDados(api?.response?.data);
		} else {
			message.error(api.response.message);
		}
		setLoading(false);
	};

	// CARREGAR
	const carregarSugestaoAnexo = async (id) => {
		setLoading(true);
		const api = await http("get", `v1/sugestoes_anexos/carregar/${id}`, []);
		if (api.statusCode === 200) {
			// DOWNLOAD FILE
			let a = document.createElement("a");
			a.href = "data:application/octet-stream;base64," + api?.response?.data?.arquivo;
			a.download = api?.response?.data?.nome;
			a.click();
		} else {
			message.error(api.response.message);
		}
		setLoading(false);
	};

	// COLUNAS
	const columns = [
		{
			title: "Nº",
			dataIndex: "id",
			sorter: (a, b) => a.id?.toString()?.localeCompare(b.id?.toString()),
		},
		{
			title: "Nome",
			dataIndex: "nome",
			sorter: (a, b) => a.nome?.localeCompare(b.nome),
		},
		{
			title: "Ações",
			width: 80,
			render: (_, e) => (
				<Space.Compact>
					<Tooltip title="Baixar">
						<Button loading={loading} onClick={() => carregarSugestaoAnexo(e.id)} icon={<DownloadOutlined />} />
					</Tooltip>
				</Space.Compact>
			),
			dataIndex: "acoes",
		},
	];

	return (
		<React.Fragment>
			<Space direction="vertical" style={{ width: "100%" }}>
				<Table rowKey="id" loading={loading} scroll={{ x: 700 }} columns={columns} dataSource={dados} size="small" />
			</Space>
		</React.Fragment>
	);
};
